<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <div class="integral-panel">
          <div class="integral">{{ integral }}</div>
          <div class="text">当前可用积分</div>
        </div>
        <c-panel-container v-if="integralDetails.length>0">
          <c-panel-title>积分明细</c-panel-title>
          <c-panel v-for="(item,index) in integralDetails"
                   :title="item.title" :desc="item.time"
                   :key="index">
            <span class="price" v-if="parseInt(item.integral)>0">+{{ item.integral }}</span>
            <span class="sub-price" v-else>{{ item.integral }}</span>
          </c-panel>
        </c-panel-container>
        <div class="empty" v-else>
          暂无积分明细
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>/
<script>
  import AboutUser from '../../../model/about-user'
  export default{
    data () {
      return {
        aboutUser: new AboutUser(),
        integralDetails: [],
        integral: 0
      }
    },
    components: {},
    created () {
      this.aboutUser.integral().then(res => {
        this.integral = res.accountIntegral
      }).catch(e => {
      })
      this.aboutUser.integralDetail().then(res => {
        this.integralDetails = res
      }).catch(e => {
      })
    },
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?94144300